// app/javascript/controllers/token_reveal_controller.js
import { Controller } from "@hotwired/stimulus"

// Token#name is the live API bearer secret. Only admins can reach the tokens
// page at all, so this is not an access control — it keeps the value off screen
// during screen shares and screenshots until an admin asks for it.
export default class extends Controller {
  static targets = ["masked", "value", "showIcon", "hideIcon"]

  connect() {
    this.hide()
  }

  toggle(event) {
    event.preventDefault()
    this.valueTarget.classList.contains("hidden") ? this.show() : this.hide()
  }

  show() {
    this.maskedTarget.classList.add("hidden")
    this.valueTarget.classList.remove("hidden")
    this.showIconTarget.classList.add("hidden")
    this.hideIconTarget.classList.remove("hidden")
    this.element.setAttribute("aria-expanded", "true")
  }

  hide() {
    this.valueTarget.classList.add("hidden")
    this.maskedTarget.classList.remove("hidden")
    this.hideIconTarget.classList.add("hidden")
    this.showIconTarget.classList.remove("hidden")
    this.element.setAttribute("aria-expanded", "false")
  }
}
